import {
  type BoidAssignmentState,
  type BoidAssignmentTableData,
  boidAssignmentStateKey,
  statusFor
} from "../model";
import {editTableBadgeMetaData} from "../table/editTableBadgeMetaData";

export const toBoidAssignmentTableData = (
    state: BoidAssignmentState,
    t: (key: string) => string,
    entityId: string
): BoidAssignmentTableData => {
  const operationalBoidStatus = statusFor(state, entityId);

  return {
    key: boidAssignmentStateKey(state),
    product: t(`entity-detail.business-operation-types.${state.type}`),
    type: state.type,
    id: state.id,
    operationalBoidStatus,
    operationalBoidStatusLabel: t(editTableBadgeMetaData(operationalBoidStatus).labelKey!),
    sourceCaId: state.sourceCaId,
    clientBoidStatus: state.subAccountStatus,
    boidAssignmentState: state
  };
};
